import React from 'react';
import { fieldConfig } from './../../conf/config';
import { validate } from './validation';

import Aux from './../../hoc/_Aux';
import Input from './../../containers/UI/Input/Input';

const generateInputState = (field) => {
   
    if(typeof fieldConfig[field] === 'undefined') {
        return;
    }else{
        if(fieldConfig[field].elementType==="html" ){
            return {
                htmlContent: fieldConfig[field].htmlContent,
                elementType: fieldConfig[field].elementType,
            }
        }else if(fieldConfig[field].elementType==="link") {
          return {
              elementType: fieldConfig[field].elementType,
              text: fieldConfig[field].text,
              destination: fieldConfig[field].destination,
          }
      }else if(fieldConfig[field].elementType==="label") {
            return {
                elementType: fieldConfig[field].elementType,
                label: fieldConfig[field].label,
                options: fieldConfig[field].options,
            }
        }else{
            return {
                elementType: fieldConfig[field].elementType,
                elementConfig: {
                    type: fieldConfig[field].type,
                    placeholder: fieldConfig[field].placeholder
                },
                title: fieldConfig[field].title,
                label: fieldConfig[field].label,
                labelPosition: fieldConfig[field].labelPosition,
                options: fieldConfig[field].options,
                value: fieldConfig[field].defaultValue,
                validation: fieldConfig[field].validation,
                valid: false,
                errorMessage: '',
                touched: false
            }
        }
    }
}

const overrideInputControls = (controls, overridingValues) => {
    for (var field in overridingValues)
    {
        for (var option in overridingValues[field])
        {
            switch (option)
            {
                case 'placeholder':
                    controls[field]['elementConfig']['placeholder'] = overridingValues[field][option];
                    break;
                case 'defaultValue':
                    controls[field]['value'] = overridingValues[field][option];
                    break;
           
                default:
                    controls[field][option] = overridingValues[field][option];
            }
            
        }
    }

    return controls;
}

export const generateInputControls = (fields, overridingValues) => {
    var controls ={};

    for (let key in fields)
    {
        // check if this is an element whose name has been set
        let fieldElement = fields[key].split('_');
        let fieldType = (fieldElement.length===2)?fieldElement[0]:fields[key];

        controls[fields[key]] = generateInputState(fieldType);
        // for submit element, they're always valid
        if(fieldType==="submit" || fieldType==="avatar"){
            controls[fields[key]]['valid']=true;
        }
    }
    if(typeof overridingValues !== 'undefined')
    {
        controls = overrideInputControls(controls, overridingValues);
    }

    return controls;
}

//Must be a fonction and not an arrow function because it will take the wrong context
export function onChangedHandler( event, controlName ){
   
    let newValue = event.target.value;
    if(this.state.controls[controlName].elementConfig.type==="checkbox"){
        newValue = (parseInt(event.target.value, 10)===0)?1:0;
    }

    const validation = validate( newValue, this.state.controls[controlName].validation );

    const updatedControls = {
        ...this.state.controls,
        [controlName]: {
            ...this.state.controls[controlName],
            value: newValue,
            valid: validation['isValid'],
            errorMessage: validation['errorMessage'],
            touched: true
        }
    };
    
    this.setState( { controls: updatedControls } );
}

//Must be a fonction and not an arrow function because it will take the wrong context
export function onChangedPlacesAutoCompleteHandler(city, controlName) {
    let getCity = city;
    getCity = getCity.split(', ');
    if(getCity.length > 1)
    {
        getCity = getCity[getCity.length - 2];
        city = getCity;
    }
    
    const validation = validate( city, this.state.controls[controlName].validation );
    const updatedControls = {
        ...this.state.controls,
        [controlName]: {
            ...this.state.controls[controlName],
            value: city,
            valid: validation['isValid'],
            errorMessage: validation['errorMessage'],
            touched: true
        }
    };
    this.setState( { controls: updatedControls } );
}

const generateInput = (obj, formElement ) => {
  let elementType = formElement.id.split('_');
        
  if(formElement.config.elementType==="link"){
    return(
      <div className="input-group" key={formElement.id}>
        <a href={formElement.config.destination}>
          {formElement.config.text}
        </a>
      </div>
  )
  }else if(formElement.config.elementType==="label"){

      let elementClasses = ['label-row', (elementType.length===2)?elementType[1]:''];
      return (
          <span className={elementClasses.join(' ')} key={formElement.id} >{formElement.config.title}</span>
      )
  }else{
      let elementClass = [(elementType.length===2)?elementType[1]:''];
      return (
          <Input
              key={formElement.id}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              classes={elementClass}
              name={formElement.id}
              title={formElement.config.title}
              label={formElement.config.label}
              labelPosition={formElement.config.labelPosition}
              options={formElement.config.options}
              value={formElement.config.value}
              invalid={!formElement.config.valid}
              errorMessage={formElement.config.errorMessage}
              shouldValidate={formElement.config.validation}
              touched={formElement.config.touched}
              changed={( event ) => obj.inputChangedHandler( event, formElement.id )}
              changedPlacesAutoComplete={( city ) => obj.inputChangedPlacesAutoCompleteHandler( city, formElement.id )} />
      )
  }
}

export const generateForm = (obj, controls, order) => {

  let form;

  if(typeof order === 'object' && !Array.isArray(order)) //Block case
  {
    let orderData = Object.entries(order);
    form = orderData.map(object => {
        return(
          <div className={object[0]} key={"Container_" + object[0]}>
            {generateForm(obj, controls, object[1])}
          </div>
        )
      })
  }
  else if (typeof order === 'object') //array case
  {
    form = order.map(entrie => {
      return(
        <Aux key={entrie}>
          {generateForm(obj, controls, entrie)}
        </Aux>
      )
    })
  }
  else if (typeof order === 'undefined') //no order passed
  {
    const formElementsArray = [];
    for ( let key in controls ) {
      if(typeof controls[key] !== 'undefined')
      {
        formElementsArray.push(key);
      }
    }

    form = generateForm(obj, controls, formElementsArray);

  }
  else { //input case
    form = (
      <Aux>
          {generateInput(obj, {id:order, config:controls[order]})}
      </Aux>
    )
  }

  return form;
}


// WEBPACK FOOTER //
// ./src/utils/form/generateFormTools.js